var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSoundOn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.113,
    height: 18.773,
    viewBox: "0 0 20.113 18.773",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fafafa;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1234",
    "data-name": "Group 1234",
    transform: "translate(10611.518 13899.725)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    className: "cls-1",
    d: "M483.333,1122.434a.668.668,0,0,0-.709.08l-6.522,5.218h-3.116a1.343,1.343,0,0,0-1.341,1.341v5.364a1.342,1.342,0,0,0,1.341,1.341H476.1l6.521,5.218a.672.672,0,0,0,.711.079.67.67,0,0,0,.38-.6v-17.432A.672.672,0,0,0,483.333,1122.434Z",
    transform: "translate(-11083.162 -15022.092)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    className: "cls-1",
    d: "M520.283,1137.328a.671.671,0,0,0-.942.955,5.348,5.348,0,0,1,0,7.573.67.67,0,1,0,.942.952,6.687,6.687,0,0,0,0-9.48Z",
    transform: "translate(-11116.339 -15032.407)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    className: "cls-1",
    d: "M526.555,1131.058a.671.671,0,1,0-.946.952,8,8,0,0,1,0,11.356.671.671,0,0,0,.946.952,9.345,9.345,0,0,0,0-13.26Z",
    transform: "translate(-11120.719 -15028.026)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSoundOn);
export default __webpack_public_path__ + "static/media/Icon_SoundON.77e7291a3386dcabde43cf5d592de6b5.svg";
export { ForwardRef as ReactComponent };